import React, {useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';
import {ChromePicker} from 'react-color';

import useModal from 'hooks/useModal';
import Modal from 'components/Modal';
import Loader from 'components/Loader';

import useColor from 'hooks/useColor';

function ModalChooseColor(props) {
	let {
		forceOpen = false,
		edit = false
	} = props;

	const {
		isShowing,
		hide,
		show,
		fetching
	} = useModal();


	const {
		has: hasColors,
		colors,
		saveColors,
		initialised,
		palettes,
		paletteIndex
	} = useColor();


	const {t} = useTranslation();
	const [color, setColor] = useState('#FFFFFF');
	const [count, setCount] = useState(1000);
	const [countTransparent, setCountTransparent] = useState(1000);
	const [name, setName] = useState('Palette 1');
	const [currentColors, setCurrentColors] = useState(colors);

	const validateColor = (color, count) => {
		let temp = [...currentColors];
		let exist = false;
		temp.map((currentColor, index) => {
			if (currentColor.color === color) {
				temp[index].count = count;
				exist = true;
			}
			return true;
		});
		if (exist === false) {
			temp.push({
				color,
				count
			});
		}
		setCurrentColors(temp);
	}

	useEffect(() => {
		if (hasColors === false && initialised) {
			show();
		}
	}, [colors, hasColors, show, initialised]);

	useEffect(() => {
		if (hasColors && initialised) {
			if (forceOpen && !isShowing) {
				if (edit) {
					setName(palettes[paletteIndex].name);
					setCurrentColors(palettes[paletteIndex].colors);
				} else {
					setName('');
					setCurrentColors([]);
				}
				return show();
			}
			if (!forceOpen && isShowing) {
				hide();
			}
		}
	}, [forceOpen, show, hasColors, initialised, hide, isShowing]);

	const closeModal = () => {
		if (typeof props.setForceOpenOpen === 'function') {
			props.setForceOpenOpen(false);
		}
		hide();
	}

	const deleteColor = (i) => {
		let nexColor = [];
		currentColors.map((currentColor, index) => {
			if (index !== i) {
				nexColor.push(currentColor);
			}
			return true;
		});
		setCurrentColors(nexColor);
	}

	return (
		<Modal
			isShowing={isShowing}
			hide={closeModal}
			title={t('PopInColor.title')}
			closeButton={forceOpen ? true : false}
		>
			{fetching && (
				<Loader />
			)}
			{!fetching && (
				<div className="colors-choose">

					<div className="row g-3">
						<div className="col-md-6">
							<label htmlFor="inputPassword4"
							       className="form-label">{t('ModalChooseColor.color')}</label>
							<ChromePicker
								color={color}
								disableAlpha={true}
								onChangeComplete={(c) => {
									setColor(c.hex);
								}}
							/>
							<div className="wrapper-transparent-color">
								<input
									id="nbr-domino"
									className="form-control"
									type="number"
									min="0"
									max="100000"
									onChange={(evt) => {
										setCountTransparent(evt.target.value)
									}}
									defaultValue={countTransparent}
								/>
								<button
									onClick={() => {
										validateColor('transparent', countTransparent);
									}}
									type="submit"
									className="btn btn-primary add-color"
								>
									{t('ModalChooseColor.addTransparent')}
								</button>
							</div>
						</div>
						<div className="col-md-6">
							<label htmlFor="nbr-domino"
							       className="form-label">{t('ModalChooseColor.nbrDomino')}</label>
							<input
								id="nbr-domino"
								className="form-control"
								type="number"
								min="0"
								max="100000"
								onChange={(evt) => {
									setCount(evt.target.value)
								}}
								defaultValue={count}
							/>

							<div className="wrapper-btn-add">
								<button
									onClick={() => {
										validateColor(color, count);
									}}
									type="submit"
									className="btn btn-primary add-color"
								>
									{t('add')}
								</button>

							</div>
						</div>
					</div>
					<div className="row g-0 separator">
						<div className="col">
							<div className="progress progress-xs">
								<div className="progress-bar" role="progressbar" aria-valuenow="30" aria-valuemin="0"
								     aria-valuemax="100"></div>
							</div>
						</div>
					</div>
					<div>

						<div className="colors-container">
							<label htmlFor="palette-name"
							       className="form-label">{t('ModalChooseColor.colors')}</label>
							{currentColors.length === 0 && (
								<p className="noColors">{t('ModalChooseColor.noColors')}</p>
							)}
							<ul>
								{currentColors.map((colorData, indexColor) => {
									return (
										<li key={'color' + indexColor}>
											<div
												className={'color-render domino-' + colorData.color}
												style={{backgroundColor: colorData.color}}
											>
												<div className="wrapper-delete"
												     onClick={() => {
													     deleteColor(indexColor);
												     }}
												>
													<svg viewBox="0 0 24 24" width="10" height="10"
													     stroke="currentColor" strokeWidth="2" fill="none"
													     strokeLinecap="round" strokeLinejoin="round"
													     className="css-i6dzq1">
														<polyline points="3 6 5 6 21 6"></polyline>
														<path
															d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
													</svg>
												</div>


												{colorData.count}
											</div>
										</li>
									)
								})}
							</ul>
						</div>

						<label htmlFor="palette-name"
						       className="form-label">{t('ModalChooseColor.namePalette')}</label>
						<input
							id="palette-name"
							className="form-control"
							onChange={(evt) => {
								setName(evt.target.value)
							}}
							defaultValue={name}
						/>

						<div className="wrapper-btn-save">
							<button
								onClick={() => {
									let id = false;
									if (edit) {
										id = palettes[paletteIndex].id;
									}
									saveColors(
										id,
										name,
										currentColors,
										closeModal
									);
								}}
								type="submit"
								className="btn btn-primary btn-save"
							>
								{t('Sauvegarder')}
							</button>
						</div>

					</div>
				</div>
			)}

		</Modal>
	);
}

export default ModalChooseColor;
